<!--suppress JSUnresolvedVariable -->
<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">游戏列表</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <el-button
          @click="addGame(0)"
          size="small"
          plain
          type="primary"
          :disabled="!adminPermissions.includes('/game/admin/addOrUpdateGame')"
        >
          添加游戏
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="gameList"
        tooltip-effect="dark"
        style="width: 100%;"
        height="417"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column prop="gameName" label="游戏名称" align="center">
        </el-table-column>
        <el-table-column
          prop="gameDownloads"
          sortable
          label="Android下载"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="gameClicks"
          sortable
          label="IOS点击"
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" align="center" width="170">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="已上架"
              inactive-text="未上架"
              :disabled="
                !adminPermissions.includes('/game/admin/addOrUpdateGame')
              "
              @change="value => gameStatusChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="首页显示" align="center" width="138">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.homeShow"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              :disabled="
                !adminPermissions.includes('/game/admin/addOrUpdateGame')
              "
              @change="value => isHomeShowChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="标签" prop="gameTag" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.gameTag === 0">无</el-tag>
            <el-tag type="danger" v-if="scope.row.gameTag === 1">hot</el-tag>
            <el-tag type="success" v-if="scope.row.gameTag === 2">推荐</el-tag>
            <el-tag type="warning" v-if="scope.row.gameTag === 3">新上</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          sortable
          label="添加时间"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot="header" slot-scope="scope">
            <el-input
              type="text"
              v-model="keywordSearch"
              size="mini"
              placeholder="输入关键字,按回车开始搜索"
              @keyup.enter.native="startSearch(scope)"
            />
          </template>
          <template slot-scope="scope">
            <el-button
              @click="editGameInfo(scope.row.gameId)"
              type="primary"
              plain
              size="small"
              :disabled="
                !adminPermissions.includes('/game/admin/addOrUpdateGame')
              "
              >编辑
            </el-button>

            <el-button
              type="danger"
              slot="reference"
              plain
              @click="deleteGameById(scope.row.gameId)"
              size="small"
              :disabled="!adminPermissions.includes('/game/admin/deleteGame')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pt-3">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "GameList",
  data() {
    return {
      gameList: [],
      keywords: "",
      adminPermissions: this.$store.state.adminPermissions,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keywordSearch: ""
    };
  },
  mounted() {
    this.getGameList();
  },
  methods: {
    getGameList() {
      this.loading = true;
      this.axios
        .get("/game/admin/getGameList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.gameList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    startSearch() {
      this.loading = true;
      this.axios
        .get("/game/getGameByKeyword", {
          params: {
            currentPage: 1,
            pageSize: this.pageSize,
            keyword: this.keywordSearch
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.gameList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getGameList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGameList();
    },
    gameStatusChange(status, game) {
      this.axios
        .post("/game/admin/addOrUpdateGame", {
          gameId: game.gameId,
          status: status,
          homeShow: game.homeShow
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (status) {
              this.$notify({
                title: "成功",
                message: "游戏已上架",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "游戏已下架",
                type: "success"
              });
            }
          }
        });
    },
    isHomeShowChange(value, game) {
      this.axios
        .post("/game/admin/addOrUpdateGame", {
          gameId: game.gameId,
          status: game.status,
          homeShow: value
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (value) {
              this.$notify({
                title: "成功",
                message: "已设置为首页显示",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "已取消首页显示",
                type: "success"
              });
            }
          }
        });
    },
    editGameInfo(gameId) {
      this.$router
        .push({ name: "GameForm", params: { gameId: gameId } })
        .catch();
    },
    addGame(gameId) {
      this.$router
        .push({ name: "GameForm", params: { gameId: gameId } })
        .catch();
    },
    deleteGameById(gameId) {
      this.$confirm("此操作将永久删除该游戏, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .delete("/game/admin/deleteGame", {
              params: {
                gameId: gameId
              }
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.getGameList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped></style>
